import React, {useState} from 'react';
import Login from './Login';
import Register from './Register';
import {useQuery} from '@apollo/client';
import logo from '../../logo.svg';
import {request} from '../../utils/api';
import { useLocation } from 'react-router-dom';

const Auth = ({onLogin, user, userLoading}) => {
  const [page, setPage] = useState('login');
  const [loading, setLoading] = useState('');
  const [error, setError] = useState(null);

  const {search} = useLocation();

  const login = ({username, password}) => {
    setLoading(true);
    setError(null);
    request({method: 'post', url: '/api-token-auth', data: {username, password}})
      .then(res => {
        if (res.data.token) {
          onLogin(res.data.token);
          setLoading(false);
        }
      })
      .catch(e => {
        setError(e.response.data);
        setLoading(false);
      });
  };

  useState(() => {
    const params = new URLSearchParams(search);
    if (!localStorage.getItem('ref@quiz-client') && params.get('ref')) {
      localStorage.setItem('ref@quiz-client', params.get('ref'));
    }
  }, []);


  return (
    <div className="h-100 bg-light px-3">
      <div className="mx-auto col-md-9 col-lg-4 h-100 d-flex flex-column justify-content-center">
        <div className="font-6 font-weight-bold text-primary mt-5 mb-4 text-center">
          <img src={logo} alt="Quiz" height="35" />
        </div>
        <div className="row justify-content-around font-4 mb-4">
          <button
            onClick={() => setPage('login')}
            className={`col-auto btn btn-link btn-lg text-center ${page === 'login' ? 'text-primary' : 'text-warning'}`}
          >
            Логин
          </button>
          <button
            onClick={() => setPage('register')}
            className={`col-auto btn btn-link btn-lg text-center ${
              page === 'register' ? 'text-primary' : 'text-warning'
            }`}
          >
            Регистрация
          </button>
        </div>
        <div className="text-center rounded border border-secondary px-5 py-3 bg-white">
          {page === 'login' && (
            <Login login={login} loading={loading} error={error} user={user} userLoading={userLoading} />
          )}
          {page === 'register' && <Register login={login} loginLoading={loading} loadingError={error} />}
        </div>
      </div>
    </div>
  );
};

export default Auth;
